import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
const packageJson = require("../../../../package.json");

const currentVersion = packageJson.version;

const Footer = () => {
  return (
    <div className="mt-5 w-100 footer-section ">
      <Container className="d-flex flex-md-row flex-column justify-content-center align-items-center">
        <p className="text-xs text-center mb-0">
          Developed by {" "}
          <Link to="https://suretytelco.com/" target="_blank">
            SURETY-TELCO
          </Link>
          {" "} | {" "}
          Sales by {" "}
          <Link to="https://soft-techsolutions.com/" target="_blank">
            SOFT-TECH SOLUTION
          </Link>
        </p>
        <div className="text-xs ms-md-auto">
          Version <b>{currentVersion}</b>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
